import { disablePageScroll, enableScroll } from "../utils/scroll";

export default function () {
  const bookingBtn = document.querySelector('.sidebar__btn');
  const target = document.body;
  if (!bookingBtn) return;
  const bookingLink = bookingBtn.getAttribute('data-link');
  const config = { childList: true, subtree: true };

  const checkPopup = function (mutationList, observer) {
    let popupExists = false;
    for (const mutation of mutationList) {
      if (mutation.type !== 'childList') return;
      mutation.addedNodes.forEach(function (node) {
        if (node.classList.contains('calendly-overlay')) {
          popupExists = true;
        }
      });
    }

    popupExists ? disablePageScroll(true) : enableScroll();
  };

  const observer = new MutationObserver(checkPopup);

  bookingBtn.addEventListener('click', (event) => {
    event.preventDefault();
    window.Calendly?.showPopupWidget(bookingLink);
  });

  observer.observe(target, config);
}
